import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Card,
  CardBody,
  Row,
  Col,
  Collapse,
  Button
} from 'reactstrap';
import { toast } from "react-toastify";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import CategoryQuestionApi from 'apis/questions/CategoryQuestion';

import AnswerListDefault from 'components/questions/modify/AnswerListDefault';

class QuestionListNormal extends Component {
  constructor() {
    super();
    this.state = {
      collapse: false,
      addWeights: false,
      errorWeights: false,
      answers: [],
      has_weight: false,
      inputType: {},
    }
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.setState({
      answers: this.props.question.answers,
      has_weight: this.props.question.has_weight,
      inputType: this.props.question.input_type,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      answers: nextProps.question.answers,
      has_weight: nextProps.question.has_weight
    });
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggleAddWeights = () => {
    this.setState((prevState) => ({
      addWeights: !prevState.addWeights,
      errorWeights: false
    }));
  }

  saveWeights = (answerWeights) => {
    const error = this.checkWeights(answerWeights);
    if (error) {
      this.setState({
        errorWeights: error
      });
      return;
    } else {
      this.setState({
        errorWeights: false
      });
    }

    this.saveAnswerWeights(answerWeights);
    this.toggleAddWeights();
  }

  removeWeights = () => {
    const answers_attributes = this.state.answers.map(ans => {
      return {
        ...ans,
        weight: null
      }
    });
    this.updateQuestions(answers_attributes, false);
  }

  checkWeights = (answerWeights) => {
    const weights = answerWeights.map(answer => answer.weight);

    if (new Set(weights).size !== weights.length) return true;
    else false;
  }

  isCustomSurvey = () => {
    return this.props.location.pathname.includes('/custom_surveys/')
  }

  saveAnswerWeights = (answerWeights) => {
    const answers_attributes = answerWeights;

    this.updateQuestions(answers_attributes, true);
  }

  updateQuestions = (answers_attributes, has_weight) => {
    const { id: editId, question, answer_order } = this.props.question;

    CategoryQuestionApi.update(editId, question, answers_attributes, answer_order, has_weight)
      .then(({ data }) => {
        this.setState({
          answers: data.survey_template_question_answers,
          has_weight: data.has_weight
        })
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />Weights updated
        </div>
        ));
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />Error while
                updating question
            </div>
          )),
          console.log(e)
        )
      );
  }

  render() {
    const isCustomSurveyPage = this.isCustomSurvey();
    const { collapse, addWeights, errorWeights, answers, has_weight, inputType } = this.state;

    return (
      <Card className="question-answer-container">
        <CardBody>
          <Row onClick={this.toggle}>
            <Col xs="10">
              <span className="question">
                {this.props.question.question}</span>
              {this.props.question.answers.length > 0 && <span className="text-muted">({this.props.question.answers.length} options)</span>}
            </Col>
            <Col className='text-right'>
              <span className='circular-icon icon-check ml-0' onClick={this.props.editQuestion.bind(this, this.props.question.id)}><FontAwesomeIcon icon="pencil-alt" /></span>
              <span className='circular-icon icon-cross' onClick={this.props.deleteQuestion.bind(this, this.props.question.id)}><FontAwesomeIcon icon="trash-alt" /></span>
            </Col>
          </Row>
          <Collapse isOpen={collapse}>
            <CardBody>
              <AnswerListDefault
                addWeight={addWeights}
                answers={answers}
                saveWeights={this.saveWeights}
                toggleAddWeights={this.toggleAddWeights}
                inputType={inputType}
              />
              {
                isCustomSurveyPage || (inputType && inputType.id !== 1)? null :
                  !addWeights &&
                  <React.Fragment>
                    <Button className="btn-weights float-left" onClick={this.toggleAddWeights}>
                      {
                        has_weight ? `Update Weights` : `Add Weights`
                      }
                    </Button>
                    {
                      has_weight && <Button className="btn-weights float-right" onClick={this.removeWeights}>Remove weights</Button>
                    }
                  </React.Fragment>
              }
              {
                (addWeights && errorWeights) && <span className="text-danger ml-weight">Oops! The weights submitted are invalid.</span>
              }
            </CardBody>
          </Collapse>
        </CardBody>
      </Card>
    )
  }
}

export default withRouter(QuestionListNormal);



// WEBPACK FOOTER //
// ./src/components/questions/modify/QuestionListNormal.js